'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Builder = require('./Builder');

var _Builder2 = _interopRequireDefault(_Builder);

var _StaticModel2 = require('./StaticModel');

var _StaticModel3 = _interopRequireDefault(_StaticModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Model = function (_StaticModel) {
  _inherits(Model, _StaticModel);

  function Model() {
    _classCallCheck(this, Model);

    var _this = _possibleConstructorReturn(this, (Model.__proto__ || Object.getPrototypeOf(Model)).call(this));

    for (var _len = arguments.length, atributtes = Array(_len), _key = 0; _key < _len; _key++) {
      atributtes[_key] = arguments[_key];
    }

    if (atributtes.length === 0) {
      _this._builder = new _Builder2.default(_this);
    } else {
      Object.assign.apply(Object, [_this].concat(atributtes));
    }

    if (_this.baseURL === undefined) {
      throw new Error('You must declare baseURL() method.');
    }

    if (_this.request === undefined) {
      throw new Error('You must declare request() method.');
    }

    if (_this.$http === undefined) {
      throw new Error('You must set $http property');
    }
    return _this;
  }

  /**
   *  Setup
   */

  _createClass(Model, [{
    key: 'resource',
    value: function resource() {
      return this.constructor.name.toLowerCase() + 's';
    }
  }, {
    key: 'primaryKey',
    value: function primaryKey() {
      return 'id';
    }
  }, {
    key: 'getPrimaryKey',
    value: function getPrimaryKey() {
      return this[this.primaryKey()];
    }
  }, {
    key: 'custom',
    value: function custom(resource) {
      this._customResource = resource;

      return this;
    }
  }, {
    key: 'hasMany',
    value: function hasMany(model) {
      var instance = new model();
      var url = this.baseURL() + '/' + this.resource() + '/' + this.getPrimaryKey() + '/' + instance.resource();

      instance._from(url);

      return instance;
    }
  }, {
    key: '_from',
    value: function _from(url) {
      Object.defineProperty(this, '_fromResource', { get: function get() {
          return url;
        } });
    }
  }, {
    key: 'for',
    value: function _for(object) {
      if (object instanceof Model === false) {
        throw new Error('The object referenced on for() method is not a valid Model.');
      }

      if (!this.isValidId(object.id)) {
        throw new Error('The object referenced on for() method has a invalid id.');
      }

      var url = this.baseURL() + '/' + object.resource() + '/' + object.getPrimaryKey() + '/' + this.resource();

      this._from(url);

      return this;
    }

    /**
     * Helpers
     */

  }, {
    key: 'hasId',
    value: function hasId() {
      var id = this.getPrimaryKey();
      return this.isValidId(id);
    }
  }, {
    key: 'isValidId',
    value: function isValidId(id) {
      return id !== undefined && id !== 0 && id !== '';
    }
  }, {
    key: 'endpoint',
    value: function endpoint() {
      if (this._fromResource) {
        if (this.hasId()) {
          return this._fromResource + '/' + this.getPrimaryKey();
        } else {
          return this._fromResource;
        }
      }

      if (this.hasId()) {
        return this.baseURL() + '/' + this.resource() + '/' + this.getPrimaryKey();
      } else {
        return this.baseURL() + '/' + this.resource();
      }
    }

    /**
     *  Query
     */

  }, {
    key: 'include',
    value: function include() {
      var _builder;

      (_builder = this._builder).include.apply(_builder, arguments);

      return this;
    }
  }, {
    key: 'append',
    value: function append() {
      var _builder2;

      (_builder2 = this._builder).append.apply(_builder2, arguments);

      return this;
    }
  }, {
    key: 'select',
    value: function select() {
      var _builder3;

      (_builder3 = this._builder).select.apply(_builder3, arguments);

      return this;
    }
  }, {
    key: 'where',
    value: function where(field, value) {
      this._builder.where(field, value);

      return this;
    }
  }, {
    key: 'whereIn',
    value: function whereIn(field, array) {
      this._builder.whereIn(field, array);

      return this;
    }
  }, {
    key: 'orderBy',
    value: function orderBy() {
      var _builder4;

      (_builder4 = this._builder).orderBy.apply(_builder4, arguments);

      return this;
    }
  }, {
    key: 'page',
    value: function page(value) {
      this._builder.page(value);

      return this;
    }
  }, {
    key: 'limit',
    value: function limit(value) {
      this._builder.limit(value);

      return this;
    }
  }, {
    key: 'params',
    value: function params(payload) {
      this._builder.params(payload);

      return this;
    }

    /**
     * Result
     */

  }, {
    key: 'first',
    value: function first() {
      return this.get().then(function (response) {
        var item = void 0;

        if (response.data) {
          item = response.data[0];
        } else {
          item = response[0];
        }

        return item || {};
      });
    }
  }, {
    key: 'find',
    value: function find(identifier) {
      var _this2 = this;

      if (identifier === undefined) {
        throw new Error('You must specify the param on find() method.');
      }
      var base = this._fromResource || this.baseURL() + '/' + this.resource();
      var url = base + '/' + identifier + this._builder.query();

      return this.request({
        url: url,
        method: 'GET'
      }).then(function (response) {
        return new _this2.constructor(response.data);
      });
    }
  }, {
    key: 'get',
    value: function get() {
      var _this3 = this;

      var base = this._fromResource || this.baseURL() + '/' + this.resource();
      base = this._customResource || base;
      var url = '' + base + this._builder.query();

      return this.request({
        url: url,
        method: 'GET'
      }).then(function (response) {
        var collection = response.data.data || response.data;
        collection = Array.isArray(collection) ? collection : [collection];

        collection = collection.map(function (c) {
          var item = new _this3.constructor(c);
          Object.defineProperty(item, '_fromResource', { get: function get() {
              return _this3._fromResource;
            } });

          return item;
        });

        if (response.data.data !== undefined) {
          response.data.data = collection;
        } else {
          response.data = collection;
        }

        return response.data;
      });
    }
  }, {
    key: '$get',
    value: function $get() {
      return this.get().then(function (response) {
        return response.data || response;
      });
    }

    /**
     * Common CRUD operations
     */

  }, {
    key: 'delete',
    value: function _delete() {
      if (!this.hasId()) {
        throw new Error('This model has a empty ID.');
      }

      return this.request({
        url: this.endpoint(),
        method: 'DELETE'
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: 'save',
    value: function save() {
      return this.hasId() ? this._update() : this._create();
    }
  }, {
    key: '_create',
    value: function _create() {
      var _this4 = this;

      return this.request({
        method: 'POST',
        url: this.endpoint(),
        data: this
      }).then(function (response) {
        var self = Object.assign(_this4, response.data);
        return self;
      });
    }
  }, {
    key: '_update',
    value: function _update() {
      var _this5 = this;

      return this.request({
        method: 'PUT',
        url: this.endpoint(),
        data: this
      }).then(function (response) {
        var self = Object.assign(_this5, response.data);
        return self;
      });
    }

    /**
     * Relationship operations
     */

  }, {
    key: 'attach',
    value: function attach(params) {
      return this.request({
        method: 'POST',
        url: this.endpoint(),
        data: params
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: 'sync',
    value: function sync(params) {
      return this.request({
        method: 'PUT',
        url: this.endpoint(),
        data: params
      }).then(function (response) {
        return response;
      });
    }
  }, {
    key: '$http',
    get: function get() {
      return Model.$http;
    }
  }]);

  return Model;
}(_StaticModel3.default);

exports.default = Model;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-api-query/build/Model.js
// module id = jthT
// module chunks = 40